export default __webpack_public_path__ + "static/CBX-Mapa-Parking-MAY2023-solo-nombres-ISOMETRICO-completo-ENG-f1f67266a1017db39e876ae19e40d491.png";